import { render, staticRenderFns } from "./picDetails.vue?vue&type=template&id=4ba61cd7&scoped=true"
import script from "./picDetails.vue?vue&type=script&lang=js"
export * from "./picDetails.vue?vue&type=script&lang=js"
import style0 from "./picDetails.vue?vue&type=style&index=0&id=4ba61cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba61cd7",
  null
  
)

export default component.exports